import React from 'react';
import '../styles/SafeAreaView.css'; // Assume you add the CSS above in this file

const SafeAreaView = ({ children }) => {
  return <div className="safe-area">{children}</div>;
};

export default SafeAreaView;
